/* ============================================================
   SINGSPACE ADMIN - SWITCH PARAMÈTRES (Pro Max)
   ============================================================ */

import { Switch } from '@/components/ui/switch';
// import { Label } from '@/components/ui/label';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  description?: string;
}

export function ToggleSwitch({ checked, onChange, label, description }: ToggleSwitchProps) {
  return (
    <div
      className="flex items-center justify-between py-6 border-b border-gray-50 last:border-none group cursor-pointer"
      onClick={() => onChange(!checked)}
    >
      <div className="space-y-1 pr-8">
        <p className="text-sm font-black text-[#00303c] uppercase tracking-tight group-hover:text-[#00758d] transition-colors">
          {label}
        </p>
        {description && <p className="text-[11px] font-bold text-slate-400 leading-relaxed max-w-md">{description}</p>}
      </div>
      <div className="flex-shrink-0" onClick={(e) => e.stopPropagation()}>
        <Switch checked={checked} onCheckedChange={onChange} className="data-[state=checked]:bg-[#00758d]" />
      </div>
    </div>
  );
}
